/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360NfcStickersAbstractionsFiltersNfcStickerRequest {
    SearchTerm?: string;
    /**
     * 1 = Product, 2 = InformationCard, 3 = Offer, 4 = CheckOut, 5 = CheckIn
     */
    NfcStickerType?: Open360NfcStickersAbstractionsFiltersNfcStickerRequest.NfcStickerTypeEnum;
    SearchAfterStickerID?: string;
    PlaceIDs?: Array<number>;
    DateFrom?: Date;
    DateTo?: Date;
    Limit?: number;
}
export namespace Open360NfcStickersAbstractionsFiltersNfcStickerRequest {
    export type NfcStickerTypeEnum = 1 | 2 | 3 | 4 | 5;
    export const NfcStickerTypeEnum = {
        NUMBER_1: 1 as NfcStickerTypeEnum,
        NUMBER_2: 2 as NfcStickerTypeEnum,
        NUMBER_3: 3 as NfcStickerTypeEnum,
        NUMBER_4: 4 as NfcStickerTypeEnum,
        NUMBER_5: 5 as NfcStickerTypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360NfcStickersAbstractionsFiltersNfcStickerRequest.ts